module.exports = __webpack_public_path__ + "img/vip-banner-bg.3dd28892.png";